import { Box, Image, Text } from '@fairfashion/design-system'

import { LoginForm } from '../LoginForm/login-form.comp'

import * as Styles from './login-home.styles'

export const LoginHome = () => {
  return (
    <Box
      position="relative"
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
    >
      <Styles.Background />

      <Styles.LeftContainer
        padding={5}
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        width="55%"
        height="100vh"
      >
        <Box width="100%">
          <Image
            alt="Logo"
            width="173px"
            height="auto"
            src="/assets/white-logo.svg"
          />
        </Box>
        <Styles.TextContainer borderRadius="16px" width="100%" padding={3}>
          <Styles.TextBox width="100%">
            <Text size="small" color="white">
              Fair Fashion é uma plataforma Blockchain para a rastreabilidade da
              cadeia de suprimentos da indústria da moda que possibilita
              transparência os processos de produção e colaboração entre todos
              os envolvidos.
            </Text>
          </Styles.TextBox>
        </Styles.TextContainer>
      </Styles.LeftContainer>
      <Box flex={1} height="100%" alignItems="center" justifyContent="center">
        <Box
          direction="column"
          alignItems="center"
          width="90%"
          maxWidth="320px"
          gap={3}
        >
          <Box direction="column" gap={1}>
            <Text variant="h4" color="grey_1">
              Login
            </Text>
            <Text color="grey_2">Olá, Bem-vindo(a) a Fair Fashion.</Text>
          </Box>
          <LoginForm />
        </Box>
      </Box>
    </Box>
  )
}
